
import React, { useState } from "react";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { supabase } from "@/integrations/supabase/client";
import { toast } from "@/hooks/use-toast";
import { Loader2, RefreshCw, Key } from "lucide-react";

const ApiKeySync = () => {
  const [isSyncing, setIsSyncing] = useState(false);

  const syncApiKeys = async () => {
    setIsSyncing(true);
    try {
      console.log('🔄 Iniciando sincronização de chaves API...');
      
      const { data: sessionData } = await supabase.auth.getSession();
      
      const { data, error } = await supabase.functions.invoke('sync-api-keys', {
        headers: {
          Authorization: `Bearer ${sessionData.session?.access_token}`
        }
      });

      if (error) {
        console.error('❌ Erro na sincronização:', error);
        throw error;
      }

      console.log('✅ Sincronização concluída:', data);
      
      toast({
        title: "Sincronização Concluída",
        description: `Chaves API sincronizadas com sucesso. Google Vision: ${data.google_vision_key_present ? 'Configurada' : 'Não encontrada'}`,
      });
    } catch (error) {
      console.error('❌ Erro ao sincronizar chaves API:', error);
      toast({
        title: "Erro na Sincronização",
        description: "Não foi possível sincronizar as chaves API. Verifique os logs.",
        variant: "destructive",
      });
    } finally {
      setIsSyncing(false);
    }
  };

  return (
    <Card>
      <CardHeader>
        <CardTitle className="flex items-center gap-2">
          <Key className="h-5 w-5" />
          Sincronização de Chaves API
        </CardTitle>
        <CardDescription>
          Sincronize as chaves API dos secrets do Supabase para a tabela de configurações
        </CardDescription>
      </CardHeader>
      <CardContent className="space-y-4">
        <div className="text-sm text-muted-foreground">
          <p>Esta função sincroniza as chaves API configuradas nos secrets do Supabase (como GOOGLE_VISION_API_KEY) 
          para a tabela api_settings no banco de dados.</p>
        </div>
        
        <Button 
          onClick={syncApiKeys}
          disabled={isSyncing}
          className="w-full"
        >
          {isSyncing ? (
            <>
              <Loader2 className="mr-2 h-4 w-4 animate-spin" />
              Sincronizando...
            </>
          ) : (
            <>
              <RefreshCw className="mr-2 h-4 w-4" />
              Sincronizar Chaves API
            </>
          )}
        </Button>
      </CardContent>
    </Card>
  );
};

export default ApiKeySync;
